import { store }                  from 'index';
import { SET_COMPONENTS_STATE }   from 'actions';
import { initialComponentsState } from 'reducer/initialStates';
import { objType }                from 'types';

const handleNavigate = (val: string) => {

    const state              = store.getState();
    const componentsState    = state.components;
    const setComponentsState = (payload: objType) => store.dispatch(SET_COMPONENTS_STATE(payload))
    
    setComponentsState({
        ...componentsState,
        animatePage: true
    })

    setTimeout(() => {

        if (val === 'home') {
            setComponentsState({
                ...initialComponentsState,
                page: 'home'
            })
        }

        else {
            setComponentsState({
                ...componentsState,
                page: val
            })
        }

        
    },400)
    
}


export default handleNavigate;
